import rwd from '../utils/rwd'

function Cms(settings) {
    this.windowLoaded = false

    // declare breakpoints
    this.bp = rwd.bp

    // declare media queries
    this.mq = rwd.mq
}

function ready(callback) {
    if (document.readyState != 'loading') callback()
    else document.addEventListener('DOMContentLoaded', callback)
}

Cms.prototype = {
    constructor: Cms,

    start: function () {
        var me = this

        window.addEventListener('load', function () {
            me.windowLoaded = true
        })

        this.attach()

        /**
        * Herbs search
        */
       if (document.querySelector('.herbs-search')) {
            import(
                /* webpackChunkName: "herbs-search" */ './cms/herbsSearch.js'
            ).then(({ herbsSearch }) => herbsSearch())
        }

        /**
        * Herbs list
        */
       if (document.querySelector('.herbs-section')) {
        import(
            /* webpackChunkName: "herbs-list" */ './cms/herbsList.js'
        ).then(({ herbsList }) => herbsList())
    }
    },

    /* ============================================ *
     * Attach main functions on ready
     * ============================================ */
    attach: function () {
        this.minicart()
        this.glossaryAside()
        this.adjustContent()
        this.initContentMenu()
        this.initHeydocslider()
        this.initProductsSlider()
        this.initArticlesSlider()
        this.initCategorySlider()
        this.openModal()
        this.article()
        this.moreArticles()
        this.scrollBar()

        const productsListSlider = document.getElementById('productList')
        if (window.innerWidth <= 768 && productsListSlider) {
            this.moveToArticle(productsListSlider)
        }

        const heyDocWidget = document.querySelector('.c-heydoc')
        if (heyDocWidget) {
            this.moveWidgetintoArticle(heyDocWidget)
        }
    },

    /* ============================================ *
     * Heydoc slider widget in article content
     * ============================================ */
    initHeydocslider: function () {
        const sliderEl = document.querySelectorAll(
            '[data-init="heydoc-slider"]'
        )
        if (!sliderEl.length) {
            return
        }

        function gliderAutoplay(glider, selectors, delay) {
            Array.isArray(selectors) || (selectors = [selectors])

            glider.isLastSlide = function () {
                return glider.slides[
                    glider.slides.length - 1
                ].classList.contains('visible')
            }

            const autoplayDelay = delay
            const autoplayFunction = () =>
                setInterval(function () {
                    glider.isLastSlide()
                        ? glider.scrollItem(0)
                        : glider.scrollItem('next')
                }, autoplayDelay)

            let autoplay = autoplayFunction()

            selectors.forEach((s) => {
                s.addEventListener(
                    'mouseover',
                    function () {
                        if (autoplay != null) {
                            clearInterval(autoplay)
                            autoplay = null
                        }
                    },
                    300
                )
            })

            selectors.forEach((s) => {
                s.addEventListener(
                    'mouseout',
                    function () {
                        if (autoplay == null) {
                            autoplay = autoplayFunction()
                        }
                    },
                    300
                )
            })
        }

        Array.from(sliderEl).forEach((slider) => {
            const sliderWrapper = slider.querySelector('[data-slider]')
            const leftArrow = slider.querySelector('[data-arrow="left"]')
            const rightArrow = slider.querySelector('[data-arrow="right"]')

            const sliderInstance = new Glider(sliderWrapper, {
                slidesToShow: 3,
                duration: 0.75,
                arrows: {
                    prev: leftArrow,
                    next: rightArrow
                },
                responsive: [
                    {
                        breakpoint: 320,
                        settings: {
                            slidesToShow: 1
                        }
                    },
                    {
                        breakpoint: 380,
                        settings: {
                            slidesToShow: 1.5
                        }
                    },
                    {
                        breakpoint: 450,
                        settings: {
                            slidesToShow: 1.7
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2.5,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 2.5,
                            slidesToScroll: 2
                        }
                    }
                ]
            })

            gliderAutoplay(
                sliderInstance,
                [sliderWrapper, leftArrow, rightArrow],
                4000
            )
        })
    },

    /* ============================================ *
     * Product slider for page - heydoc slider markup
     * ============================================ */
    initProductsSlider: function () {
        const sliders = document.querySelectorAll(
            '[data-init="heydoc-product-slider"]'
        )
        if (!sliders.length) {
            return
        }

        Array.from(sliders).forEach((slider) => {
            const sliderWrapper = slider.querySelector('[data-slider]')
            const leftArrow = slider.querySelector('[data-arrow="left"]')
            const rightArrow = slider.querySelector('[data-arrow="right"]')

            const sliderInstance = new Glider(sliderWrapper, {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: {
                    prev: leftArrow,
                    next: rightArrow
                },
                responsive: [
                    {
                        breakpoint: 320,
                        settings: {
                            slidesToShow: 1.5
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2.5
                        }
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3
                        }
                    }
                ]
            })
        })

        const priceBoxes = [...document.querySelectorAll('.c-heydoc__price')]
        priceBoxes.forEach(price => {
            let priceText = price.innerText
            priceText = priceText.replace(/\./g, ',')
            price.innerHTML = priceText
        })
    },

    /* ============================================ *
    * Category slider for content page
    * ============================================ */
    initCategorySlider: function () {
        const sliders = document.querySelectorAll(
            '[data-init="content-category-slider"]'
        )
        if (!sliders.length) {
            return
        }

        Array.from(sliders).forEach((slider) => {
            const sliderWrapper = slider.querySelector('[data-slider]')
            const leftArrow = slider.querySelector('[data-arrow="left"]')
            const rightArrow = slider.querySelector('[data-arrow="right"]')

            const sliderInstance = new Glider(sliderWrapper, {
                slidesToShow: 2,
                slidesToScroll: 1,
                rewind: true,
                arrows: {
                    prev: leftArrow,
                    next: rightArrow
                }
            })
        })
    },

    /* ============================================ *
     * SLider for mobile articles
     * ============================================ */
    initArticlesSlider: function () {
        const sliders = document.querySelectorAll(
            '[data-init="article-list-mobile-slider"]'
        )
        if (!sliders.length) {
            return
        }

        if (window.innerWidth < 768) {
            Array.from(sliders).forEach((slider) => {
                const sliderWrapper = slider.querySelector('[data-slider]')
                const leftArrow = slider.querySelector('[data-arrow="left"]')
                const rightArrow = slider.querySelector('[data-arrow="right"]')

                const sliderInstance = new Glider(sliderWrapper, {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    rewind: true,
                    arrows: {
                        prev: leftArrow,
                        next: rightArrow
                    }
                })
            })
        }
    },

    /* ============================================ *
     * Open modal in article
     * ============================================ */
    openModal: function () {
        const btn = document.querySelector('.article__verified .js-open-modal')
        if (btn) {
            function openModal() {
                window.$apteline.modal.OpenModal({
                    content: document.getElementById('verifiedContentText').textContent
                });
            }

            btn.addEventListener('click', function () {
                openModal()
            })
        }
    },
    /* ============================================ *
     * Get cart items to minicart counter
     * ============================================ */
    minicart: function () {
        var counter = document.getElementById('minicart-count'),
            counterCookie = Cookies.get('aoestatic_w1_numberofitemsincart')
        if (counter !== null) {
            if (counterCookie.length > 0) {
                counter.innerHTML = counterCookie
            } else {
                counter.innerHTML = '0'
            }
        }
    },

    /* ============================================ *
     * Glossary in aside
     * ============================================ */
    glossaryAside: function () {
        var dict = document.querySelector('.aside-dict'),
            subst = document.querySelectorAll(
                '.aside-dict [data-word="substance"]'
            )

        if (dict !== null && subst !== null) {
            var max = 8,
                randoms = [],
                articleSubst = Array.from(
                    dict.querySelectorAll('[data-word="article"]')
                ),
                subst = Array.from(subst)

            if (
                subst.length + articleSubst.length > max &&
                articleSubst.length < max
            ) {
                var i = 0
                while (i < max - articleSubst.length) {
                    // generate random from substances count range
                    // and check if exist in our randoms array
                    var random = randomRange(0, subst.length - 1)

                    if (randoms.indexOf(random) !== -1) {
                        continue
                    }

                    randoms.push(random)
                    subst[random].classList.remove('hidden')

                    i++
                }
            } else {
                subst.forEach(function (el) {
                    el.classList.remove('hidden')
                })
            }
        }

        function randomRange(min, max) {
            return ~~(Math.random() * (max - min + 1)) + min
        }
    },

    /* ============================================ *
     * Move element to article
     * ============================================ */

    moveToArticle: function (element) {
        const h2s = document.querySelectorAll(
            '.article-page article.article h2'
        )

        if (h2s.length) {
            let middleOfArticle = h2s[h2s.length >= 3 ? 2 : h2s.length - 1]
            middleOfArticle.prepend(element)
        }
    },

    /* ============================================ *
    * Scroll to table of contents headers
    * ============================================ */

    article: function () {
        const leadForm = document.getElementById('lead-form')
        if (leadForm) {
            const mail = document.getElementById('email'),
                agreement = document.getElementById('agreement'),
                errorBox = document.getElementById('validation-msg'),
                agreementBox = document.querySelector('.lead-form__agreement'),
                fieldset = document.querySelector('.lead-form__fieldset')

            leadForm.addEventListener("submit", (event) => {
                if (!mail.validity.valid || !agreement.validity.valid) {
                    event.preventDefault();
                    showErrorMsg();
                }
            })

            function showErrorMsg() {
                if (mail.validity.valueMissing) {
                    errorBox.textContent = 'Wpisz swój adres e-mail, aby pobrać darmowy materiał'
                }
                if (mail.validity.typeMismatch && !mail.validity.valueMissing) {
                    errorBox.textContent = 'Poprawny format maila to mail@example.com'
                }
                if (agreement.validity.valueMissing) {
                    fieldset.classList.add('validation-failed')
                }
            }

            mail.addEventListener("focus", (event) => {
                errorBox.textContent = ''
            });

            agreementBox.addEventListener("click", (event) => {
                fieldset.classList.remove('validation-failed')
            });
        }
    },

    /* ============================================ *
     * Show more articles
     * ============================================ */

    moreArticles: function () {
        const articleList = document.querySelector('.js-article-section')
        if (articleList) {

            const firstArticles = document.querySelectorAll('.article-show .article-sample');
            const articles = document.querySelectorAll('.article-sample');

            function changeArticleUrl(entries) {
                entries.map((entry) => {
                  if (entry.isIntersecting) {
                    const url = entry.target.dataset.url + '?a'
                    const title = entry.target.dataset.title
                    const allVisible = entry.target.parentElement.classList.contains('all-visible')
                    const firstSection = entry.target.parentElement.classList.contains('article-show')

                    if (allVisible || firstSection) {
                        window.history.replaceState({}, "", url)
                        document.title = title
                    }
                  }
                });
            }
            const articlesObserver = new IntersectionObserver(changeArticleUrl,  {threshold: 0.5});
            articles.forEach(el => articlesObserver.observe(el));

            function showArticles(entries) {
                entries.map((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('is-visible')
                        observer.unobserve(entry.target)
                    }
                });
            }

            const observer = new IntersectionObserver(showArticles);
            firstArticles.forEach(article => observer.observe(article));

            const more = document.querySelectorAll('.js-more-articles')

            if (more) {
                more.forEach((link) => {
                    link.addEventListener('click',function() {
                        this.classList.add('hidden')
                        link.parentElement.parentElement.classList.add('all-visible')
                    })
                })
            }

            const pageUrl = window.location.pathname
            const pageTitle = document.title
            function mainIntersection(entries) {
                entries.map((entry) => {
                    if (!entry.isIntersecting && window.location.pathname !== pageUrl ) {
                        window.history.replaceState({}, "", pageUrl)
                        document.title = pageTitle
                    }
                });
            }

            const mainObserver = new IntersectionObserver(mainIntersection);
            mainObserver.observe(articleList)
        }
    },

    /* ============================================ *
    * Slider scroll progress bar
    * ============================================ */
    scrollBar: function () {
        const slider = document.querySelector('.category-slider__wrapper ul')
        const bar = document.getElementById('category-slider-scroll')

        if (slider) {

            function styleProgressBarr(el) {
                const val = el.value,
                    min = 0,
                    max = 100,
                    possibleValues = max - min,
                    percentRaw = ((val - min) / possibleValues) * 100,
                    percent = +percentRaw.toFixed(2),
                    width = "--percent";

                el.style.setProperty(width, `${percent}%`);
            }

            slider.addEventListener("scroll", (event) => {
                let total = slider.scrollWidth - slider.offsetWidth;
                let percentage = slider.scrollLeft / total
                bar.value = percentage * 100
                styleProgressBarr(bar)
            });

            bar.oninput = function () {
                let total = slider.scrollWidth - slider.offsetWidth;
                slider.scrollLeft = total * (this.value / 100);
                styleProgressBarr(bar)
            }
        }
    },

    /* ============================================ *
     * Move widget into article
     * ============================================ */

    moveWidgetintoArticle: function (element) {
        const headers = document.querySelectorAll(
            '.article-page article.article h2'
        )
        if (headers.length >= 4) {
            let newPosition = headers[3];
            newPosition.prepend(element)
        }
    },

    /* ============================================ *
     * Adjust content
     * ============================================ */
    adjustContent: function () {
        var toolbar = document.querySelector('.adjust-bar'),
            font = 10
        if (toolbar !== null) {
            toolbar
                .querySelector('[data-adjust="contrast"]')
                .addEventListener('click', function () {
                    document.documentElement.classList.toggle(
                        'adjusted-contrast'
                    )
                })
            Array.from(
                toolbar.querySelectorAll('[data-adjust="font"]')
            ).forEach(function (el) {
                el.addEventListener('click', function () {
                    switch (this.dataset.fontSize) {
                        case 'small':
                            font > 6 ? font-- : font
                            break
                        case 'medium':
                            font = 10
                            break
                        case 'big':
                            font < 14 ? font++ : font
                            break
                    }
                    if (font >= 6 && font <= 14) {
                        document.documentElement.style.fontSize = font + 'px'
                    }
                })
            })
        }
    },

    /* ============================================ *
     * Content menu
     * ============================================ */
    initContentMenu: function () {
        if (!document.querySelector('.content-menu .level1')) {
            return;
        }

        this.setupMenuBasics();
        this.attachMenuEventListeners();
        this.initActiveMenuItems();
        this.setupHomepageMenuBehavior();
        this.setupBreadcrumbs();
        this.moveHeadersBetweenViews();
        this.initWcagButtons();
        this.attachAriaLabels();
    },

    setupMenuBasics: function() {
        document.querySelector('.content-menu .level1').style.display = 'block';

        Array.from(
            document.querySelectorAll('.content-menu .level1')
        ).forEach(level1 => level1.style.display = 'block');
    },

    attachMenuEventListeners: function() {
        this.attachWcagButtonListeners();
        this.attachMobileMenuListeners();
        this.attachOverlayControlListeners();
        this.attachDesktopMenuLeaveListener();
    },

    attachWcagButtonListeners: function() {
        document.documentElement.addEventListener(
            'click',
            event => {
                if (!event.target.matches('.submenu-toggle') && !event.target.closest('.submenu-toggle')) {
                    return;
                }

                event.preventDefault();
                event.stopPropagation();

                const button = event.target.closest('.submenu-toggle');
                const listItem = button.closest('li');
                const isDesktop = listItem.closest('.content-menu--desktop') !== null;

                if (isDesktop) {
                    this.handleDesktopWcagButtonClick(button, listItem);
                } else {
                    this.handleMobileWcagButtonClick(button, listItem);
                }
            },
            false
        );
    },

    handleDesktopWcagButtonClick: function(button, listItem) {
        const contentMenu = listItem.closest('.content-menu');
        const expanded = button.getAttribute('aria-expanded') === 'true';

        if (expanded) {
            button.setAttribute('aria-expanded', 'false');
            listItem.classList.remove('selected');
            contentMenu.classList.remove('expanded');
            contentMenu.querySelector('.content-menu__submenu-childs').innerHTML = '';
        } else {
            this.collapseAllMenuItems(contentMenu);

            button.setAttribute('aria-expanded', 'true');
            listItem.classList.add('selected');
            contentMenu.classList.add('expanded');

            this.cloneSubmenuToContainer(listItem, contentMenu);
        }
    },

    handleMobileWcagButtonClick: function(button, listItem) {
        const submenu = listItem.nextElementSibling;

        if (submenu && submenu.tagName === 'UL') {
            const expanded = button.getAttribute('aria-expanded') === 'true';
            button.setAttribute('aria-expanded', !expanded);

            if (expanded) {
                listItem.classList.remove('selected');
                submenu.classList.remove('selected');
            } else {
                listItem.classList.add('selected');
                submenu.classList.add('selected');
            }

            listItem.scrollIntoView({ behavior: 'smooth' });
        }
    },

    collapseAllMenuItems: function(contentMenu) {
        const allItems = contentMenu.querySelectorAll('.level1 > li');

        allItems.forEach(item => {
            item.classList.remove('selected');
            const itemButton = item.querySelector('.submenu-toggle');
            if (itemButton) {
                itemButton.setAttribute('aria-expanded', 'false');
            }
        });
    },

    cloneSubmenuToContainer: function(listItem, contentMenu) {
        const submenuContainer = contentMenu.querySelector('.content-menu__submenu-childs');
        const linkText = listItem.querySelector('a').innerText;

        submenuContainer.innerHTML = `<div class="content-menu__subcategory-title">${linkText}</div>`;

        const submenu = listItem.nextElementSibling?.cloneNode(true);
        if (submenu) {
            const children = Array.from(submenu.children);
            children.forEach(child => submenuContainer.appendChild(child));
        }
    },

    attachMobileMenuListeners: function() {
        document.documentElement.addEventListener(
            'click',
            event => {
                this.showArticles(event)
            },
            false
        );
        document.documentElement.addEventListener(
            'keydown',
            event => {
                if (event.key === 'Enter' || event.key === ' ') {
                    this.showArticles(event);
                }
            },
            false
        );
    },

    attachAriaLabels: function() {
        const menuItems = document.querySelectorAll('.level-1');
        menuItems.forEach(item => {
          const link = item.querySelector('a');
          const text = link.textContent.trim();
          item.setAttribute('aria-label', 'Rozwiń podmenu: ' + text);
        });
    },

    showArticles: function(event) {
        const isMobileMenu = event.target.closest('.content-menu--overlay') !== null;

        if (isMobileMenu && event.target.matches('.content-menu--overlay .level1 > li')) {
            const listItem = event.target;
            const submenu = listItem.querySelector('ul');
            if (submenu && submenu.tagName === 'UL') {
                event.preventDefault();

                const isExpanded = listItem.classList.contains('selected');
                if (isExpanded) {
                    this.collapseMenuItem(listItem, submenu);
                } else {
                    this.expandMenuItem(listItem, submenu);
                }

                listItem.scrollIntoView({ behavior: 'smooth' });
            }
        }

        if (event.target.tagName === 'A') {
            return;
        }
    },

    expandMenuItem: function(listItem, submenu) {
        listItem.classList.add('selected');
        submenu.classList.add('selected');

        const button = listItem.querySelector('.submenu-toggle');
        if (button) {
            button.setAttribute('aria-expanded', 'true');
        }
    },

    collapseMenuItem: function(listItem, submenu) {
        listItem.classList.remove('selected');
        submenu.classList.remove('selected');

        const button = listItem.querySelector('.submenu-toggle');
        if (button) {
            button.setAttribute('aria-expanded', 'false');
        }
    },

    attachOverlayControlListeners: function() {
        document.documentElement.addEventListener(
            'click',
            event => {
                showMenu(event);
            },
            false
        );

        document.documentElement.addEventListener(
            'click',
            event => {
                if (event.target.matches('.open-content-overlay, .open-content-overlay img, .open-content-overlay span')) {
                    event.preventDefault();
                    const anchor = document.querySelector('.content-menu--overlay-anchor');
                    if (anchor) {
                        anchor.style.display = 'block';
                        const closeButton = anchor.querySelector('.content-menu__close.js-icon-close');

                        if (closeButton) {
                            closeButton.focus();
                      }
                    }
                }
            },
            false
        );

        document.documentElement.addEventListener(
        'keydown',
        event => {
            if (event.key === 'Enter' || event.key === ' ') {
                if (event.target.matches('.content-menu__close.js-icon-close')) {
                    event.preventDefault();
                    const anchor = document.querySelector('.content-menu--overlay-anchor');
                    if (anchor) {
                        anchor.style.display = 'none';
                        const showMenuBtn = document.querySelector('.btn.btn--bg.btn--block.btn--flex-center.btn--title.open-content-overlay')
                        if (showMenuBtn) {
                            showMenuBtn.focus()
                        }
                    }
                }
            }
          },
          false
        );

      document.documentElement.addEventListener(
        'keydown',
        event => {
          if (event.key === 'Enter' || event.key === ' ') {
            if (event.target.matches('.open-content-overlay, .open-content-overlay img, .open-content-overlay span')) {
              event.preventDefault();
              const anchor = document.querySelector('.content-menu--overlay-anchor');
              if (anchor) {
                anchor.style.display = 'block';
                const closeButton = anchor.querySelector('.content-menu__close.js-icon-close');

                if (closeButton) {
                  closeButton.focus();
                }
              }
            }
          }
        },
        false
      );
    },

    initActiveMenuItems: function() {
        let $target = this.findActiveMenuElements();

        $target.forEach(target => {
            target.classList.add('selected');

            if (window.innerWidth < 992) {
                const link = target.querySelector('a');
                if (link) {
                    link.style.display = 'inline-block';
                }
            }

            this.setupActiveSublistItems(target);
        });
    },

    findActiveMenuElements: function() {
        let $target = [];
        if (window.innerWidth >= 992) {
            $target = Array.from(
                document.querySelectorAll('.content-menu--desktop .level1 > .active')
            );
        } else {
            $target = Array.from(
                document.querySelectorAll('.content-menu--overlay-sub .level1 > .active')
            );
        }

        let $isNextList = true;

        while ($target.length > 1) {
            $target.forEach(el => {
                if ($isNextList) {
                    $target = [];
                    $target.push(el.querySelector('ul'));
                } else {
                    $target = Array.from(el.querySelectorAll('.active'));
                }
                $isNextList = !$isNextList;
            });
        }

        return $target;
    },

    setupActiveSublistItems: function(target) {
        const sublist = Array.from(target.querySelectorAll('.active'));

        if (sublist.length) {
            Array.from(
                sublist[sublist.length - 1].querySelectorAll('ul > li')
            ).forEach(el => {
                if (el.parentElement.parentElement.classList.contains('active')) {
                    el.classList.add('selected');
                }
            });
        } else {
            Array.from(target.querySelectorAll('ul > li')).forEach(el => {
                if (el.parentElement.parentElement.classList.contains('active')) {
                    el.classList.add('selected');
                }
            });
        }
    },

    setupHomepageMenuBehavior: function() {
        const MENU_ITEMS = Array.from(
            document.querySelectorAll('.content-menu--desktop .level1 > li')
        );

        if (!MENU_ITEMS.some(item => item.classList.contains('active'))) {
            MENU_ITEMS.forEach(item => {
                this.attachMouseEnterListener(item);

                this.attachMouseLeaveListener(item);
            });
        }
    },

    attachMouseEnterListener: function(item) {
        item.addEventListener(
            'mouseenter',
            event => {
                if (event.target.matches('.submenu-toggle') || event.target.closest('.submenu-toggle')) {
                    return;
                }

                const contentMenu = item.closest('.content-menu');

                contentMenu.querySelectorAll('.level1 > li .submenu-toggle').forEach(btn => {
                    btn.setAttribute('aria-expanded', 'false');
                });

                item.classList.add('selected');
                contentMenu.classList.add('expanded');
                contentMenu.querySelector('.content-menu__submenu-childs').innerHTML =
                    `<div class="content-menu__subcategory-title">${event.target.firstChild.innerText != undefined ? event.target.firstChild.innerText : event.target.innerText}</div>`;

                const el = event.target.nodeName === 'A' ? event.target.parentNode : event.target;
                const submenu = el.cloneNode(true);

                if (submenu) {
                    Array.from(submenu.children).forEach(child => {
                          if (child.nodeName === 'UL') {
                          contentMenu.querySelector('.content-menu__submenu-childs').appendChild(child)
                        }
                      }
                    );

                    const button = item.querySelector('.submenu-toggle');
                    if (button) {
                        button.setAttribute('aria-expanded', 'true');
                    }
                }
            },
            true
        );
    },

    attachMouseLeaveListener: function(item) {
        item.addEventListener(
            'mouseleave',
            event => {
                if (event.target.matches('.submenu-toggle') || event.target.closest('.submenu-toggle')) {
                    return;
                }

                if (
                    event?.relatedTarget?.classList?.contains('content-menu__submenu') ||
                    event?.target?.classList?.contains('content-menu') ||
                    event?.target?.classList?.contains('content-menu__submenu') ||
                    event?.target?.parentElement?.nodeName === 'LI'
                ) {
                    return;
                }

                const contentMenu = item.closest('.content-menu');
                item.classList.remove('selected');
                contentMenu.classList.remove('expanded');
                contentMenu.querySelector('.content-menu__submenu-childs').innerHTML = '';

                const button = item.querySelector('.submenu-toggle');
                if (button) {
                    button.setAttribute('aria-expanded', 'false');
                }
            },
            true
        );
    },

    attachDesktopMenuLeaveListener: function() {
        const desktopMenu = document.querySelector('.content-menu--desktop');
        if (desktopMenu) {
            desktopMenu.addEventListener('mouseleave', () => {
                const contentMenu = document.querySelector('.content-menu.expanded');
                if (contentMenu) {
                    const selectedItem = contentMenu.querySelector('li.selected');
                    if (selectedItem) {
                        selectedItem.classList.remove('selected');

                        const button = selectedItem.querySelector('.submenu-toggle');
                        if (button) {
                            button.setAttribute('aria-expanded', 'false');
                        }
                    }

                    contentMenu.classList.remove('expanded');
                    contentMenu.querySelector('.content-menu__submenu-childs').innerHTML = '';
                }
            });
        }
    },

    setupBreadcrumbs: function() {
        if (!document.querySelector('.breadcrumbs') || document.querySelector('.breadcrumbs').childElementCount <= 2) {
            return;
        }

        const breadcrumbEl = document.querySelector('.breadcrumbs li:nth-last-child(2)').innerHTML;
        const $target = this.findActiveMenuElements();

        $target.forEach(target => {
            const goBackEl = document.createElement('span');
            goBackEl.className = 'content-menu__underline';
            goBackEl.innerHTML = `cofnij do ${breadcrumbEl}`;

            if (window.innerWidth > 991) {
                const parentList = target.parentNode;
                if (parentList) {
                    parentList.insertBefore(goBackEl, target);
                }
            } else {
                const categoryContainer = document.querySelector('.js-move-cms-title-category');
                if (categoryContainer && categoryContainer.parentElement) {
                    categoryContainer.parentElement.appendChild(goBackEl);
                }
            }
        });

        const subheader = document.querySelector('.content-menu--overlay-sub .content-menu__subheader');
        if (subheader) {
            subheader.innerHTML = breadcrumbEl;
        }
    },

    moveHeadersBetweenViews: function() {
        if (window.innerWidth <= 991) {
            return;
        }

        const cmsTitleHomepage = document.querySelector('.js-move-cms-title-homepage');
        if (cmsTitleHomepage) {
            const categories = document.querySelector('.content-menu--desktop .content-menu__categories');
            if (categories) {
                categories.prepend(cmsTitleHomepage);
            }
        }

        const cmsTitleCategory = document.querySelector('.js-move-cms-title-category');
        if (cmsTitleCategory) {
            const desktopMenu = document.querySelector('.content-menu--desktop');
            if (desktopMenu) {
                desktopMenu.prepend(cmsTitleCategory);
            }
        }
    },

    initWcagButtons: function() {
        const submenuButtons = document.querySelectorAll('.submenu-toggle');

        submenuButtons.forEach(button => {
            this.initWcagButtonState(button);
            this.addKeyboardSupport(button);
            this.addFocusSupport(button);
        });
    },

    initWcagButtonState: function(button) {
        const listItem = button.closest('li');
        const submenu = listItem.nextElementSibling;

        if (submenu && submenu.tagName === 'UL') {
            const isActive = listItem.classList.contains('active') ||
                submenu.classList.contains('selected');

            button.setAttribute('aria-expanded', isActive ? 'true' : 'false');

            if (isActive && !submenu.classList.contains('selected')) {
                submenu.classList.add('selected');
            }
        }
    },

    addKeyboardSupport: function(button) {
        button.addEventListener('keydown', event => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                button.click();
            }
        });
    },

    addFocusSupport: function(button) {
        if (button.closest('.content-menu--desktop')) {
            button.addEventListener('focus', () => {
                button.classList.add('focus-visible');
            });

            button.addEventListener('blur', () => {
                button.classList.remove('focus-visible');
            });
        }
    }
}

function showMenu(event) {
    if (event.target.matches('.content-menu--overlay .js-icon-close, .content-menu--overlay-sub .icon-close')) {
        event.preventDefault();
        const anchor = document.querySelector('.content-menu--overlay-anchor');

        if (anchor) {
            anchor.style.display = 'none';
            const closeButton = anchor.querySelector('.content-menu__close.js-icon-close');

            if (closeButton) {
                closeButton.focus();
            }
        }
    }
}

ready(function () {
    var cms = new Cms()
    cms.start()
})
    ; (function (arr) {
        arr.forEach(function (item) {
            if (item.hasOwnProperty('prepend')) {
                return
            }
            Object.defineProperty(item, 'prepend', {
                configurable: true,
                enumerable: true,
                writable: true,
                value: function prepend() {
                    var argArr = Array.prototype.slice.call(arguments),
                        docFrag = document.createDocumentFragment()

                    argArr.forEach(function (argItem) {
                        var isNode = argItem instanceof Node
                        docFrag.appendChild(
                            isNode
                                ? argItem
                                : document.createTextNode(String(argItem))
                        )
                    })

                    this.insertBefore(docFrag, this.firstChild)
                }
            })
        })
    })([Element.prototype, Document.prototype, DocumentFragment.prototype])
